export default "__VITE_ASSET__Dn$i4exT__"